import { render, staticRenderFns } from "./CompanyStatistics.vue?vue&type=template&id=3ba5ccee&scoped=true&"
import script from "./CompanyStatistics.vue?vue&type=script&lang=js&"
export * from "./CompanyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStatistics.vue?vue&type=style&index=0&id=3ba5ccee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5ccee",
  null
  
)

export default component.exports